export var accountTypes = {
    GUID: "guid",
};
export var enrollmentType = {
    PAPER: "PAPER",
    ELECTRONIC: "ELECTRONIC",
    ELECTRONIC_AND_PAPER: "ELECTRONIC_AND_PAPER",
};
